"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.useDbStoreInitial = useDbStoreInitial, exports.useDbStore = useDbStore;

var _get = require("lodash/get"),
    _get2 = _interopRequireDefault(_get),
    _react = require("react"),
    _reactReduxFirebase = require("react-redux-firebase");

function _interopRequireDefault(a) {
  return a && a.__esModule ? a : {
    default: a
  };
}

function useDbStoreInitial(a) {
  var b = (0, _get2.default)(a, ["db", "type"], "firestore"),
      c = (0, _get2.default)(a, ["db", "init"]);
  return "firestore" === b && (c ? (0, _reactReduxFirebase.useFirestoreConnect)(c) : (0, _reactReduxFirebase.useFirestoreConnect)(a.initialQueries)), (0, _react.useEffect)(function () {
    ("custom" === b || "srcmstore" === b) && c && c();
  }, []), null;
}

function useDbStore(a) {
  var b = (0, _get2.default)(a, ["db", "type"], "firestore");

  if ("custom" === b || "srcmstore" === b) {
    var c = (0, _get2.default)(a, ["db", "ops"]);
    if (!!c) return c;
  }

  if ("firestore" === b) {
    var d = (0, _reactReduxFirebase.useFirestore)();
    return {
      setMerge: function e(a, b, c) {
        return d.set(a + "/" + b, c, {
          merge: !0
        });
      },
      // Promise returns nothing on success 
      setOverwrite: function e(a, b, c) {
        return d.doc(a + "/" + b).set(c);
      },
      // Promise returns nothing on success 
      get: function c(a, b) {
        return d.doc(a + "/" + b).get();
      },
      // Promise gets firestore document object on success
      exists: function c(a, b) {
        return d.doc(a + "/" + b).get().then(function (a) {
          return a.exists;
        });
      },
      // Promise returns true/false
      delete: function c(a, b) {
        return d.delete(a + "/" + b).catch(alert);
      },
      // Promise returns nothing on success
      getSnapshot: function b(a) {
        return d.get(a);
      } // Promise returns firestore document list (snapshot) on success

    };
  }

  return {
    setMerge: function setMerge() {},
    setOverwrite: function setOverwrite() {},
    get: function get() {},
    exists: function a() {
      return !1;
    },
    delete: function _delete() {},
    getSnapshot: function getSnapshot() {}
  };
}